const PRIMARY_COLOR = '#004E00';
const WHITE = '#FFFFFF';
const BTN_COLOR = 'linear-gradient(180deg, #00DE00 0%, #008500 97.5%, #008500 98.5%)';
const NAVBAR_COLOR = 'linear-gradient(180deg, #007800 19.5%, #00D800 100%)';
const APPBAR_COLOR = 'transparent';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    backgroundColor: WHITE,
    appbarColor: APPBAR_COLOR,
    navbarColor: NAVBAR_COLOR,
    buttonColor: BTN_COLOR,
    buttonHoverColor: BTN_COLOR,
}

export default lightTheme;